import People from './people'

export default People